import { translate as $t } from '@/lang'
import { defaultDate } from '@/util/date'

export const tableOption = {
  size: 'medium',
  align: 'center',
  searchBtnText: $t('common.inquire'),
  searchBtnIcon: ' ',
  addBtn: false,
  searchShowBtn: false,
  refreshBtn: false,
  searchMenuSpan: 5,
  highlightCurrentRow: true,
  emptyBtn: false,
  delBtn: false,
  editBtn: false,
  menuWidth: 100,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  menuClassName: 'crud__menu',
  column: [
    {
      label: $t('addOrganDrug.organDrugId'),
      prop: 'drugId',
      searchLabelWidth: '94',
      search: true,
      placeholder: $t('common.pleaseInput') + $t('addOrganDrug.organDrugId')
    },
    {
      label: $t('addOrganDrug.drugName'),
      prop: 'drugName',
      search: true,
      placeholder: $t('common.pleaseInput') + $t('addOrganDrug.drugName')
    },
    {
      label: $t('addOrganDrug.drugSpec'),
      prop: 'specification',
      search: true,
      placeholder: $t('common.pleaseInput') + $t('addOrganDrug.drugSpec')
    },
    {
      label: $t('addOrganDrug.drugType'),
      prop: 'drugType',
      search: true,
      type: 'select',
      placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.drugType'),
      dicData: [{ label: $t('addOrganDrug.westDrug'), value: 1 }, { label: $t('addOrganDrug.chineseDrug'), value: 3 }]
    },
    {
      width: 200,
      label: $t('addOrganDrug.createTime'),
      prop: 'date',
      type: 'daterange',
      display: false,
      search: true,
      searchRange: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      startPlaceholder: $t('common.startTime'),
      endPlaceholder: $t('common.endTime'),
      searchSpan: 8,
      clearable: false,
      hide: true,
      searchValue: defaultDate().dataArr
    },
    {
      label: $t('addOrganDrug.dosage'),
      prop: 'dosage'
    },
    {
      label: $t('addOrganDrug.dosageUnit'),
      prop: 'dosageUnit'
    },
    {
      label: $t('addOrganDrug.auditStatus'),
      prop: 'status',
      formatter: (row) => {
        return row.status == 0 ? '待审核' : row.status == 1 ? '审核通过' : row.status == 2 ? '审核不通过' : ''
      }
    },
    {
      label: $t('addOrganDrug.unpassReason'),
      prop: 'auditReason'
    },
    {
      label: $t('addOrganDrug.diseaseLink'),
      prop: 'diagnose'
    }
  ]
}

export const statusList = [
  {
    id: '0',
    name: $t('common.auditing')
  },
  {
    id: '1',
    name: $t('common.auditPass')
  },
  {
    id: '2',
    name: $t('common.auditUnpass')
  }
]

export const formOption = (currentDrugId) => {
  return {
    size: 'medium',
    labelWidth: 100,
    emptyBtn: false,
    submitBtn: !currentDrugId,
    column: [
      {
        label: $t('addOrganDrug.drugType'),
        prop: 'drugType',
        type: 'select',
        cascader: ['usage'],
        span: 12,
        disabled: !!currentDrugId,
        clearable: false,
        placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.drugType'),
        dicData: [{ label: $t('addOrganDrug.westDrug'), value: 1 }, { label: $t('addOrganDrug.chineseDrug'), value: 2 }],
        control: (val) => {
          if (val == 1) {
            return {
              specification: { display: true },
              frequencyName: { display: true },
              packingUnit: { display: true }
            }
          }
          if (val == 2) {
            return {
              specification: { display: false },
              frequencyName: { display: false },
              packingUnit: { display: false }
            }
          }
        },
        value: 1,
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.drugType'),
            trigger: 'change'
          }
        ]
      },
      {
        label: $t('addOrganDrug.organDrugId'),
        prop: 'drugId',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.organDrugId'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseInput') + $t('addOrganDrug.organDrugId'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: $t('addOrganDrug.drugName'),
        prop: 'drugName',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.drugName'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseInput') + $t('addOrganDrug.drugName'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: $t('addOrganDrug.drugSpec'),
        prop: 'specification',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.drugSpec'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseInput') + $t('addOrganDrug.drugSpec'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: $t('addOrganDrug.usage'),
        prop: 'usage',
        type: 'select',
        span: 12,
        props: {
          label: 'name',
          value: 'name'
        },
        dicUrl: '/doctor/drugs/getUsage?type={{key}}',
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.usage'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.usage'),
            trigger: 'change'
          }
        ]
      },
      {
        label: $t('addOrganDrug.frequency'),
        prop: 'frequencyName',
        type: 'select',
        span: 12,
        props: {
          label: 'name',
          value: 'name'
        },
        dicUrl: '/doctor/drugs/frequency',
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.frequency'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.frequency'),
            trigger: 'change'
          }
        ]
      },
      {
        label: $t('addOrganDrug.dosage'),
        prop: 'dosage',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.dosage'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseInput') + $t('addOrganDrug.dosage'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: $t('addOrganDrug.dosageUnit'),
        prop: 'dosageUnit',
        type: 'select',
        span: 12,
        props: {
          label: 'name',
          value: 'name'
        },
        dicUrl: '/doctor/drugs/getDosageUnit',
        dicFormatter: (res) => {
          return res.data ? res.data.map(item => ({ name: item })) : []
        },
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.dosageUnit'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.dosageUnit'),
            trigger: 'change'
          }
        ]
      },
      {
        label: $t('addOrganDrug.packageUnit'),
        prop: 'packingUnit',
        type: 'select',
        span: 12,
        props: {
          label: 'name',
          value: 'name'
        },
        dicUrl: '/doctor/drugs/getPackageUnit',
        dicFormatter: (res) => {
          return res.data ? res.data.map(item => ({ name: item })) : []
        },
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseSelect') + $t('addOrganDrug.packageUnit'),
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.packageUnit'),
            trigger: 'change'
          }
        ]
      },
      {
        label: $t('addOrganDrug.manufacturer'),
        prop: 'manufacturer',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.manufacturer')
      },
      {
        label: $t('addOrganDrug.barCode'),
        prop: 'barCode',
        span: 12,
        disabled: !!currentDrugId,
        placeholder: $t('common.pleaseInput') + $t('addOrganDrug.barCode')
      },
      {
        label: $t('addOrganDrug.diseaseLink'),
        prop: 'diagnoseList',
        span: 24,
        rules: [
          {
            required: true,
            message: $t('common.pleaseSelect') + $t('addOrganDrug.diseaseLink')
          }
        ]
      }
    ]
  }
}
